<template lang="html">
  <div class="info-wallet--inner">
    <div class="user-details--title">
      <button class="btn--create"
        @click="checkCreate()"
      >
        <i class="ico--create"></i>
      </button>

      <span>Wallets</span>
    </div>
    <div class="user-details-toolbar">
      <div class="user-details-toolbar__items">
        <select-list
          class="toolbar-nav"
          :title="selectedList"
          v-model="selectedList"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

          <select-option
            value="undeleted"
            name="undeleted"
          >
            <span>undeleted</span>
          </select-option>

          <select-option
            value="deleted"
            name="deleted"
          >
            <span>deleted</span>
          </select-option>

        </select-list>
      </div>
    </div>

    <check-data-list
      label="loading"
      v-if="isDataLoading || isEmpty"
      :isLoading="isDataLoading"
      :isEmpty="isEmpty"
    >
    </check-data-list>

    <tbl
      :scrollable="true"
      :dataLoading="isDataLoading"
      :class="{'data-loading': showDataLoading}"
      v-else
    >
      <tbl-inner>
        <tbl-head>
          <tbl-row>
            <tbl-td
              :sort="true"
              @click.native="sort('id')"
              name="no">
              no
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('created_at')"
              name="date">

              create date
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('division')"
              name="division">
              division
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('bank_name')"
              name="bank-name">
              bank name
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('bank_account_name')"
              name="account-name">
              account name
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('bank_account_number')"
              name="number">
              number
            </tbl-td>

            <tbl-td name="password">
              password
            </tbl-td>

            <tbl-td name="actions">
              actions
            </tbl-td>
          </tbl-row>
        </tbl-head>

        <tbl-body>
          <tbl-row
            v-for="(wallet, x) in sortedWallets"
            :key="wallet.id"
            :class="{'is-deleted': wallet.deleted_at}"
          >
            <tbl-td name="no">
              {{ generateNumber(x, params.page, params.rows, params.sort, sortedWallets.length || 0) }}
            </tbl-td>

            <tbl-td name="date">
              {{wallet.created_at | date}}
            </tbl-td>

            <tbl-td name="division">
              {{wallet.bank_type}}
            </tbl-td>

            <tbl-td name="bank-name">
              <div
                class="select-wrap"
                v-if="walletMod.id ===  wallet.id"
              >
              <select
                v-model="walletMod.bank_id"
              >
                <option
                  v-for="bank in banks"
                  :value="bank.id"
                  :key="bank.id"
                >
                  {{ bank.name }}
                </option>
              </select>
              </div>
              <span v-else>
                {{wallet.bank_name}}
              </span>
            </tbl-td>

            <tbl-td name="account-name">
              <div
                class="input-wrap"
                v-if="walletMod.id ===  wallet.id"
              >
                <input v-model="walletMod.bank_account_name">
              </div>
              <span v-else>
                {{wallet.bank_account_name}}
              </span>
            </tbl-td>

            <tbl-td name="number">
              <div
                class="input-wrap"
                v-if="walletMod.id ===  wallet.id"
              >
                <input v-model="walletMod.bank_number">
              </div>
              <span v-else>
                {{wallet.bank_number}}
              </span>
            </tbl-td>

            <tbl-td name="password">
              <div
                class="input-wrap"
                v-if="walletMod.id ===  wallet.id"
              >
                <input v-model="walletMod.new_password">
              </div>
              <span v-else>
                {{wallet.temp | showPassword}}
              </span>

            </tbl-td>

            <tbl-td name="actions">
              <button
                class="btn--bookmark"
                :class="{'-main': wallet.is_main}"
                v-if="!wallet.deleted_at"
                @click="updateWallet(wallet.id, { is_main: !wallet.is_main })"
              >
                <i class="fa fa-wallet"></i>
              </button>

              <button
                class="btn--delete"
                @click="removeWallet(wallet.id)"
                v-if="!wallet.deleted_at"
              >
                <i class="ico--delete"></i>
              </button>

              <button
                class="btn--modify"
                @click="set(wallet)"
                v-if="!walletMod.id || walletMod.id !== wallet.id"
              >
                <i class="ico--modify"></i>
              </button>

              <button
                class="btn--create"
                v-if="walletMod.id === wallet.id"
                @click="updateWallet()"
              >
                <i class="ico--save"></i>
              </button>

              <button
                class="btn--restore"
                @click="restore(wallet.id)"
                v-if="wallet.deleted_at"
              >
                <i class="ico--restore"></i>
              </button>

            </tbl-td>
          </tbl-row>
        </tbl-body>
      </tbl-inner>
    </tbl>

    <modal
      class="modal--create-wallet"
      :title="'create wallet'"
      :activate="showCreate"
      v-if="showCreate"
      @activate="showCreate=$event"
    >
      <template slot="body">
        <div class="details details-modal">
          <div class="detail-items">
            <div class="detail-lbl">
              <span>bank number</span>
            </div>
            <div class="detail-data -disabled">
              <div class="input-wrap">
                <input v-model="wallet.bank_number">
              </div>
            </div>
          </div>

          <div class="detail-items">
            <div class="detail-lbl">
              <span>account name</span>
            </div>
            <div class="detail-data">
              <div class="input-wrap">
                <input v-model="wallet.bank_account_name">
              </div>
            </div>
          </div>

          <div class="detail-items">
            <div class="detail-lbl">
              <span>bank password</span>
            </div>
            <div class="detail-data">
              <div class="input-wrap">
                <input v-model="wallet.bank_password">
              </div>
            </div>
          </div>

          <div class="detail-items">
            <div class="detail-lbl">
              <span>bank</span>
            </div>
            <div class="detail-data">
              <select-list
                title="Banks"
                v-model="wallet.bank_id"
              >
                <select-option
                  v-for="bank  in banks"
                  :key="bank.id"
                  :name="bank.name"
                  :value="bank.id"
                  @click.native="bankType = bank.type_name"
                >
                  {{bank.name}}
                  {{bank.type_name}}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="detail-items">
            <div class="detail-lbl">
              <span>bank type</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span v-if="bankType">{{bankType}}</span>
                <span v-else>-</span>
              </div>
            </div>
          </div>

          <div class="detail-items">
            <div class="detail-lbl">
              <span>currency</span>
            </div>
            <div class="detail-data">
              <select-list
                :title="'USD'"
                v-model="wallet.currency_id"
              >
                <select-option
                  v-for="currency  in currencies"
                  :key="currency.id"
                  :name="currency.name"
                  :value="currency.id"
                >
                  {{currency.name}}
                </select-option>
              </select-list>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--create -withlabel"
          @click="save()"
        >
          <i class="ico--create"></i>
          <span>create wallet</span>
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'

//= components
import Modal from '@/components/base/Modal'
import CheckDataList from '@/components/base/CheckDataList'
import '@/components/base/table/Table'
import '@/components/base/select/Select'

export default {
  name: 'info-wallet',

  components: { Modal, CheckDataList },

  mixins: [ swal ],

  filters: {
    showPassword (pass) {
      if (pass) {
        return window.atob(pass)
      }
    }
  },

  data () {
    return {
      items: [0, 0, 0, 0, 0],
      wallet: {
        bank_account_name: '',
        bank_id: 1,
        currency_id: 1,
        bank_number: '',
        bank_password: ''
      },
      currencies: [
        { id: 1, name: 'USD' },
        { id: 2, name: 'JPY' },
        { id: 3, name: 'KRW' }
      ],
      showCreate: false,

      walletMod: {},
      bankType: null,

      selectedList: 'undeleted',

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false
    }
  },

  async created () {
    await this.getBanks({ status: 'active' })
    this.search()
  },

  computed: {
    ...mapState('userWallet', ['wallets']),
    ...mapState('user', ['user']),
    ...mapState('bank', ['banks']),

    sortedWallets () {
      return _.orderBy(this.wallets, (e) => {
        return e.is_main
      }, 'desc')
    }
  },

  watch: {
    async selectedList (val) {
      this.search()
    }
  },

  methods: {
    ...mapActions('userWallet', ['create', 'update', 'delete', 'get']),
    ...mapActions('bank', { getBanks: 'get' }),

    async search () {
      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({
        id: this.$route.params.id,
        status: this.selectedList,
        params: this.params
      })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.wallets.length) {
        this.isEmpty = true
      }
    },

    checkCreate () {
      if (this.wallets.filter((e) => { return !e.deleted_at }).length >= 5) {
        this.$alert('error', 'Reached Max Wallets', '', '', 'Cannot Create')
        return
      }
      this.showCreate = true
    },

    async save () {
      if (!this.wallet.bank_account_name || !this.wallet.bank_number || !this.wallet.bank_password) {
        this.$alert('error', 'Check input', '', '', 'Missing')
        return
      }

      if (this.wallet.bank_number.match(/[!@#$%^&*/|\()A-Za-z]/g) ||
        this.wallet.bank_password.match(/[!@#$%^&*/|\()A-Za-z]/g)) {
        this.$alert('error', 'Password or Bank Number must be of type number', '', '', 'Data Type Error')
        return
      }

      await (new Promise((resolve) => {
        this.$alert('prompt', 'Sure?', {}, () => res(true), 'Create Bank?')
      }))

      this.wallet.user_id = this.$route.params.id

      try {
        await this.create({
          data: [this.wallet],
          id: this.user.id,
          user: this.user
        })

        let wallet = JSON.parse(JSON.stringify(this.wallet))
        wallet.created_at = new Date()
        let bank = _.find(this.banks, (e) => {
          return wallet.bank_id === e.id
        })

        if (bank) {
          wallet.bank_name = bank.name
        }

        this.user.wallets.push(wallet)
        this.showCreate = false

        this.$alert('success', 'done', '', '', 'Wallet Created')
      } catch (err) {
        this.$alert('error', 'Check Data', '', '', 'Error')
      }

      try {
        await this.get({ id: this.$route.params.id, status: this.selectedList })
      } catch (err) {
        console.log(err)
      }
    },

    async updateWallet (id, data) {
      let cols = [
        'bank_id',
        'bank_account_name',
        'bank_number',
        'is_main'
      ]

      try {
        if (!id) {
          id = this.walletMod.id
          data = _.pick(this.walletMod, cols)

          if (this.walletMod.new_password) {
            data.bank_password = this.walletMod.new_password
            this.walletMod.temp = window.btoa(this.walletMod.new_password)
          }
        }

        await this.update({
          uid: this.$route.params.id,
          wid: id,
          data,
          user: this.user
        })

        this.$alert('Success', 'Updated', '', '', 'sucess')

        this.wallets.forEach((wallet) => {
          if (this.walletMod.id) {
            if (wallet.id === id) {
              wallet.bank_id = this.walletMod.bank_id
              wallet.bank_name = this.banks.find((e) => {
                return e.id === wallet.bank_id
              }).name
              wallet.bank_account_name = this.walletMod.bank_account_name
              wallet.bank_number = this.walletMod.bank_number
              wallet.temp = this.walletMod.temp
            }
          }

          if (!this.walletMod.id) {
            if (wallet.id === id) {
              wallet.is_main = 1
            } else {
              wallet.is_main = 0
            }
          }
        })

        this.walletMod = {}
      } catch (err) {

      }
    },

    async restore (id) {
      try {
        await this.update({
          uid: this.user.id,
          wid: id,
          data: { deleted_at: null },
          user: this.user
        })

        this.wallets.forEach((wallet) => {
          if (wallet.id === id) {
            wallet.deleted_at = null
          }
        })

        this.search()
      } catch (err) {

      }
    },

    async removeWallet (id) {
      try {
        this.$alert('prompt', '', {}, async () => {
          let result = await this.delete({
            uid: this.user.id,
            wid: id
          })

          this.wallets.forEach((wallet) => {
            if (wallet.id === id) {
              wallet.deleted_at = new Date()
            }
          })

          if (result === 202) {
            this.$alert('sucess', 'wallet deleted', {}, '', 'Sucess')
          }
          this.search()
        }, 'Remove wallet?')

        // await this.delete({
        //   uid: this.user.id,
        //   wid: id
        // })

        // this.user.wallets.forEach((wallet) => {
        //   if (wallet.id === id) {
        //     wallet.deleted_at = new Date()
        //   }
        // })
        // alert('deleted')
      } catch (err) {

      }
    },

    set (data) {
      this.walletMod = Object.assign({}, data)
      this.walletMod.new_password = window.atob(this.walletMod.temp)
    },

    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    }
  }
}
</script>
